import { DspAPI } from "generated-api"
import { checkIfSessionIsOrWillExpired } from "user/tools/common"
import { IDsp, IDspRepository } from "./model"

export const dspRPO: IDspRepository = {
  getAllDsp(name?: string): Promise<IDsp[]> {
    return new Promise<IDsp[]>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        DspAPI.getApiDspList(
          undefined, // offset?: number,
          undefined, // limit?: number,
          name, // search?: string,
          "contains", // match: 'exact' | 'contains' | 'starts_with' | 'ends_with' | 'not' = 'starts_with',
          undefined, // orderby?: Array<string>,
          undefined, // comparator?: Array<string>,
          undefined, // id?: Array<number>,
          true // isActive?: boolean,
        )
          .then(response => resolve(response))
          .catch(error => {
            console.error("Unexpected error while getting all dsp", error)
            reject("dsp.get.all.error.server")
          })
      } catch (ex) {
        console.error("Unexpected error while getting all dsps", ex)
        reject("dsp.get.all.error.unexpected")
      }
    })
  }
}
